import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerSalaryExcelList,
	formatWorkerSalaryList,
} from './worker-salary.helper';
import { WorkerSalaryActions } from './worker-salary.redux';
import {
	IPayloadDeleteWorkerSalaryRequest,
	IPayloadGetWorkerSalaryExcelListRequest,
	IPayloadGetWorkerSalaryListRequest,
	IUpdateWorkerSalaryRequest,
} from './worker-salary.type';

export function* getWorkerSalaryListSaga(
	action: PayloadAction<IPayloadGetWorkerSalaryListRequest>
) {
	const { searchTypes, callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerSalaryListResponse> =
			yield API.getWorkerSalaryList({ searchTypes, ...rest });
		const content = formatWorkerSalaryList(res?.data?.content);

		yield put(
			WorkerSalaryActions.getWorkerSalaryListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerSalaryActions.getWorkerSalaryListFailure());
	}
}

export function* getWorkerSalaryExcelListSaga(
	action: PayloadAction<IPayloadGetWorkerSalaryExcelListRequest>
) {
	const { searchTypes, callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerSalaryListResponse> =
			yield API.getWorkerSalaryList({ searchTypes, ...rest });
		const content = formatWorkerSalaryExcelList(res?.data?.content);

		yield put(WorkerSalaryActions.getWorkerSalaryExcelListSuccess());
		callback?.({ data: content });
	} catch (error) {
		callback?.({ error });
		yield put(WorkerSalaryActions.getWorkerSalaryExcelListFailure());
	}
}

export function* deleteWorkerSalary(
	action: PayloadAction<IPayloadDeleteWorkerSalaryRequest>
) {
	const { ids, callback } = action.payload;

	try {
		yield API.deleteWorkerSalary(ids);

		yield put(WorkerSalaryActions.deleteWorkerSalarySuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerSalaryActions.deleteWorkerSalaryFailure());
	}
}

export function* updateWorkerSalary(
	action: PayloadAction<IUpdateWorkerSalaryRequest>
) {
	const { callback, data } = action.payload;

	try {
		yield API.updateWorkerSalary(data);

		yield put(WorkerSalaryActions.updateWorkerSalarySuccess());

		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);

		yield put(WorkerSalaryActions.updateWorkerSalaryFailure());
	}
}
